import React, { memo } from 'react'
import Button from '../../components/Button'
import { ICycleCountItem } from '../../types/cycle-counts'

interface ICycleCountEditFooterProps {
  cycleCountItems: ICycleCountItem[]
  loading: boolean
  onSubmit: () => void
  onClose: () => void
  onComplete: () => void
  onRecount: () => void
  onApprove: () => void
  selectedItems: ICycleCountItem[]
}

const CycleCountEditFooter = ({
  cycleCountItems,
  loading,
  onSubmit,
  onClose,
  onComplete,
  onRecount,
  onApprove,
  selectedItems,
}: ICycleCountEditFooterProps) => {
  const approvedItems =
    cycleCountItems.filter(
      (item: ICycleCountItem) => item.status === 'approved',
    ) || []
  const rejectedItems =
    cycleCountItems.filter(
      (item: ICycleCountItem) => item.status === 'rejected',
    ) || []
  const totalItems = cycleCountItems.length || 0
  const totalVerified = approvedItems.length + rejectedItems.length

  const allReviewed = cycleCountItems.every(
    (item: ICycleCountItem) => item.status !== 'pending',
  )
  const hasRejected = cycleCountItems.some(
    (item: ICycleCountItem) => item.status === 'rejected',
  )

  const getCompleteButton = () => {
    if (allReviewed && hasRejected) {
      return (
        <Button
          type="button"
          color="danger"
          disabled={loading}
          className="form_control"
          onClick={onSubmit}
        >
          REQUEST RECOUNT
        </Button>
      )
    }

    if (allReviewed && !hasRejected) {
      return (
        <Button
          type="button"
          color="success"
          disabled={loading}
          className="form_control"
          onClick={onComplete}
        >
          COMPLETE
        </Button>
      )
    }

    return (
      <Button
        type="button"
        color="primary"
        className="form_control"
        disabled={loading}
        onClick={onClose}
      >
        Done
      </Button>
    )
  }

  return (
    <div className="form_controls cycle-count_controls-wrapper">
      <div className="cycle-count_controls">
        <div>
          <Button
            type="button"
            color={loading || selectedItems.length === 0 ? 'primary' : 'danger'}
            className="form_control"
            onClick={onRecount}
            disabled={loading || selectedItems.length === 0}
          >
            Recount
          </Button>
          <Button
            type="button"
            color={
              loading || selectedItems.length === 0 ? 'primary' : 'success'
            }
            className="form_control"
            disabled={loading || selectedItems.length === 0}
            onClick={onApprove}
          >
            Approve
          </Button>
          <div style={{ paddingLeft: 12, borderLeft: '1px solid #97A2C8' }}>
            <span className="cycle-count_verified-counter">
              {`${totalVerified} out of ${totalItems} items verified`}
            </span>
          </div>
        </div>
        {getCompleteButton()}
      </div>
    </div>
  )
}

export default memo(CycleCountEditFooter)
